import { Module, GetterTree } from 'vuex';
import { RootStoreState } from './RootStoreState';
import { LocalQuestionsTreatmentState } from './LocalQuestionsTreatmentState';

const getters: GetterTree<LocalQuestionsTreatmentState, RootStoreState> = {
  getLocalQuestionById: (state) => (id: number) => {
    return state.localQuestionsTreat.find(question => question.id === id);
  },
  getAllQuestions: (state) => {
    return state.localQuestionsTreat;
  },
   getVisibleQuestions: (state) => {
    return state.localQuestionsTreat.filter(q => !q.isHidden);
  },
  getQuestionsWithLowerTreatment: (state) => {
    const questionsWithLowerTreatment: { question: string, id: number, treatment: number }[] = [];
    for (let i = 1; i < state.localQuestionsTreat.length; i++) {
      if (state.localQuestionsTreat[i].treatment < state.localQuestionsTreat[i - 1].treatment) {
        questionsWithLowerTreatment.push(state.localQuestionsTreat[i]);
      }
    }
    return questionsWithLowerTreatment;
  }
};

const localQuestionsTreatmentModule: Module<LocalQuestionsTreatmentState, RootStoreState> = {
  namespaced: true,
  state: {
    localQuestionsTreat: [], 
    initialized: false,
    initQuestion: false,
  },
  getters,
  actions: {
    initializeLocalQuestions({ commit }, question: { question: string, id: number, treatment: number ,keyDecision: string}) { 
      commit('addLocalQuestion', question); 
    },
    updateTreatmentById({ commit }, { id, treatment }: { id: number, treatment: number }) {
      commit('setTreatmentById', { id, treatment });
    },
    setInitialized({ commit }, value: boolean) { 
      commit('setInitialized', value);
    },
    clearLocalQuestionsAndSetInitialized({ commit }) {
      commit('clearLocalQuestions'); 
      commit('setInitialized', true); 
      commit('setInitQuestion', false); 
    }
  },
  
  mutations: {
    setQuestionHidden(state, payload: { id: number; isHidden: boolean }) {
      console.log('Store setQuestionHidden called:', payload);
      const q = state.localQuestionsTreat.find(q => q.id === payload.id);
      if (q) {
        console.log(`Question ${q.question} (ID: ${payload.id}) hidden state changed from ${q.isHidden} to ${payload.isHidden}`);
        q.isHidden = payload.isHidden;
      } else {
        console.log(`Question with ID ${payload.id} not found in treatment store`);
      }
    },
    updateLocalQuestions(state: LocalQuestionsTreatmentState, questions: { question: string, id: number, treatment: number, keyDecision: string }[]) {
      state.localQuestionsTreat = questions.map(q => ({
        ...q,
        isHidden: false // Default to visible
      }));
    },
    
    addLocalQuestion(state: LocalQuestionsTreatmentState, question: { question: string, id: number, treatment: number, keyDecision: string }) {
      state.localQuestionsTreat.push({
        ...question,
        isHidden: false // Default to visible
      });
    },
    clearLocalQuestions(state: LocalQuestionsTreatmentState) {
      state.localQuestionsTreat = [];
    },
    setTreatmentById(state: LocalQuestionsTreatmentState, { id, treatment }: { id: number, treatment: number }) {
  
      let found = false;
      for (const questionObj of state.localQuestionsTreat) {
        if (questionObj.id === id) {
          questionObj.treatment = treatment;
          found = true;
          break;
        }
      }
      if (!found) {
      }
    },
    setInitialized(state: LocalQuestionsTreatmentState, value: boolean) { 
      state.initialized = value;
    },
    setInitQuestion(state: LocalQuestionsTreatmentState, value: boolean) { 
      state.initQuestion = value;
    }
  },
};

export default localQuestionsTreatmentModule;
